module.exports = __webpack_public_path__ + "img/187.ad861a2b.jpg";